import { getElementDeserializer } from '../../../../slatePlugins/common/utils/getElementDeserializer';
import { DeserializeHtml } from '../../../../slatePlugins/slatePlugins.types';
import { EDITABLE_BLANK_VOID } from './types';

export const deserializeEditableBlankVoid = (): DeserializeHtml => {
  const elmDeserialized = getElementDeserializer({
    type: EDITABLE_BLANK_VOID,
    rules: [{ className: 'blank-container' }],
  });
  return {
    element: elmDeserialized,
  };
};
